var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.009 0C9.85377 0 0 10.0736 0 22.5C0 34.9264 9.85377 45 22.009 45C34.1642 45 44.018 34.9264 44.018 22.5C44.018 10.0736 34.1642 0 22.009 0ZM22.0088 35.0144C15.248 35.0144 9.76737 29.4114 9.76737 22.4999C9.76737 15.5883 15.248 9.98534 22.0088 9.98534C27.5628 9.98534 32.2529 13.7666 33.7503 18.9483L27.7448 19.8616C26.7597 17.6272 24.562 16.0718 22.0089 16.0718C18.536 16.0718 15.7207 18.9499 15.7207 22.5003C15.7207 26.0508 18.536 28.9289 22.0089 28.9289C25.0545 28.9289 27.5944 26.7155 28.1734 23.7763L34.2454 22.8529C34.0626 29.6013 28.654 35.0144 22.0088 35.0144ZM39.2969 22.0848C39.3 22.2227 39.3016 22.3611 39.3016 22.4999C39.3016 32.2635 31.5593 40.1784 22.0088 40.1784C12.4583 40.1784 4.716 32.2635 4.716 22.4999C4.716 12.7363 12.4583 4.82129 22.0088 4.82129C30.1027 4.82129 36.8979 10.5061 38.7824 18.1831L39.8494 18.0208C40.8815 17.8639 41.8208 18.612 41.9474 19.6917C42.074 20.7715 41.3399 21.7741 40.3078 21.931L39.2969 22.0848Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5503 16L39.5369 16.7031L36.8358 19.6388L40.8244 19.1396L41.3762 19.5919L44.5503 16Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23.8549L39.9438 23.9386L37.1192 21.8119L41.2525 21.0188L45 23.8549Z",
    fill: "#256BE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5603 20.0759C41.6381 20.676 41.2261 21.2299 40.6399 21.3129L21.7551 23.9895C21.1689 24.0726 20.6307 23.6534 20.5529 23.0533C20.4751 22.4531 20.8872 21.8993 21.4733 21.8162L40.3582 19.1396C40.9443 19.0565 41.4825 19.4757 41.5603 20.0759Z",
    fill: "#256BE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.31fc0e0747455b1b84b53d3e26b0a663.svg";
export { ForwardRef as ReactComponent };